import React, { useEffect,useState,useMemo } from 'react';
import {
  Radio,
  FormControlLabel,
  FormControl,
  useMediaQuery,
} from '@mui/material';
import InputMask from 'react-input-mask';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import CloseIcon from '@mui/icons-material/Close';

import {
  StyledDialog,
  StyledDialogInputs,
  StyledDialogTitle,
  StyledDialogContent,
  StyledTypography,
  StyledButton,
  StyledSecondaryButton,
  Logo,
  StyledDialogCloseButton,
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
  StyledDialogActions,
  StyledRadioGroup,
  StyledTextField,
  StyledFormLabel,
} from './styles.js';

import LogoIcon from '../../assets/logo_mais_vendas.png';

const ProfileUpdateModal = ({ open, onClose, onSubmit }) => {
  const initialState = {
    instagram: { user: '', type: 'pessoal' },
    tiktok: { user: '', type: 'pessoal' },
    whatsapp: { user: '', type: 'pessoal' },
 };
 
  const [profileData, setProfileData] = useState(initialState);

  const hasValidChanges = useMemo(() => {
  const phone = profileData.whatsapp.user.replace(/\D/g, '');
  const phoneValid = phone.length === 0 || phone.length === 11;

  const hasAnyUser =
    profileData.instagram.user.trim() !== '' ||
    profileData.tiktok.user.trim() !== '' ||
    profileData.whatsapp.user.trim() !== '';

  return hasAnyUser && phoneValid;
}, [profileData]);

  const typeMap = {
    pessoal: 'PERSONAL',
    comercial: 'COMMERCIAL',
  };

   useEffect(() => {
    if (open) {
      setProfileData(initialState);
    }
    // eslint-disable-next-line
  }, [open]);

  const handleInputChange = (field, subfield) => e => {
    const value = e.target.value;
    setProfileData(prev => ({
      ...prev,
      [field]: {
        ...prev[field],
        [subfield]: value,
      },
    }));
  };

   const handleSubmit = () => {
    const formattedData = {
      instagram_user: profileData.instagram.user.trim(),
      instagram_type: typeMap[profileData.instagram.type],
      tiktok_user: profileData.tiktok.user.trim(),
      tiktok_type: typeMap[profileData.tiktok.type],
      phone: profileData.whatsapp.user.replace(/\D/g, ''),
      phone_type: typeMap[profileData.whatsapp.type],
    };
  
    onSubmit(formattedData); 
  };

  const isMobile = useMediaQuery('(max-width:600px)');
  const [expanded, setExpanded] = useState(false);

  const handleAccordionChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <StyledDialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <StyledDialogContent>
        {isMobile && (
          <StyledDialogCloseButton onClick={onClose}>
            <CloseIcon />
          </StyledDialogCloseButton>
        )}

        {!isMobile && <Logo component="img" image={LogoIcon} />}

        <StyledDialogTitle>
          USA REDES SOCIAIS NO SEU DIA A DIA COM CLIENTES?
        </StyledDialogTitle>

        <StyledTypography>
          Queremos saber se <strong>você usa Instagram, WhatsApp ou TikTok</strong> em alguma etapa do atendimento. <br/> Se sim, <strong>preencha seus perfis abaixo</strong>. Isso nos ajudará a entender melhor a sua rotina e pensar em formas de apoiar o seu trabalho!
        </StyledTypography>

        {isMobile ? (
          <>
            {['instagram', 'tiktok', 'whatsapp'].map(rede => (
              <StyledAccordion disableGutters
                key={rede}
                expanded={expanded === rede}
                onChange={handleAccordionChange(rede)}
              >
                <StyledAccordionSummary
                  expandIcon={expanded === rede ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                >
                  {rede.charAt(0).toUpperCase() + rede.slice(1)}
                </StyledAccordionSummary>
                <StyledAccordionDetails>
                  <FormControl fullWidth>
                    <StyledRadioGroup
                      value={profileData[rede].type}
                      onChange={handleInputChange(rede, 'type')}
                    >
                      <FormControlLabel value="pessoal" control={<Radio />} label="Pessoal" />
                      <FormControlLabel value="comercial" control={<Radio />} label="Comercial" />
                    </StyledRadioGroup>
                    {rede === 'whatsapp' ? (
                    <InputMask
                      mask="(99)99999-9999"
                      value={profileData[rede].user}
                      onChange={handleInputChange(rede, 'user')}
                    >
                      {(inputProps) => (
                        <StyledTextField
                          {...inputProps}
                          variant="outlined"
                          placeholder={`Insira seu usuário no ${rede.charAt(0).toUpperCase() + rede.slice(1)}`}
                          fullWidth
                          margin="dense"
                        />
                      )}
                    </InputMask>
                  ) : (
                    <StyledTextField
                      variant="outlined"
                      placeholder={`Insira seu usuário no ${rede.charAt(0).toUpperCase() + rede.slice(1)}`}
                      onChange={handleInputChange(rede, 'user')}
                      fullWidth
                      margin="dense"
                    />)}
                  </FormControl>
                </StyledAccordionDetails>
              </StyledAccordion>
            ))}
          </>
        ) : (
          <StyledDialogInputs>
            {['instagram', 'tiktok', 'whatsapp'].map(rede => (
              <FormControl fullWidth key={rede}>
                <StyledFormLabel>{rede.charAt(0).toUpperCase() + rede.slice(1)}:</StyledFormLabel>
                <StyledRadioGroup
                  row
                  value={profileData[rede].type}
                  onChange={handleInputChange(rede, 'type')}
                >
                  <FormControlLabel value="pessoal" control={<Radio />} label="Pessoal" />
                  <FormControlLabel value="comercial" control={<Radio />} label="Comercial" />
                </StyledRadioGroup>
                {rede === 'whatsapp' ? (
                    <InputMask
                      mask="(99)99999-9999"
                      value={profileData[rede].user}
                      onChange={handleInputChange(rede, 'user')}
                    >
                      {(inputProps) => (
                        <StyledTextField
                          {...inputProps}
                          variant="outlined"
                          placeholder={`Insira seu usuário no ${rede.charAt(0).toUpperCase() + rede.slice(1)}`}
                          fullWidth
                          margin="dense"
                        />
                      )}
                    </InputMask>
                  ) : (
                    <StyledTextField
                      variant="outlined"
                      placeholder={`Insira seu usuário no ${rede.charAt(0).toUpperCase() + rede.slice(1)}`}
                      value={profileData[rede].user}
                      onChange={handleInputChange(rede, 'user')}
                      fullWidth
                      margin="dense"
                    />)}
              </FormControl>
            ))}
          </StyledDialogInputs>
        )}

        <StyledDialogActions isMobile={isMobile}>
          <StyledSecondaryButton fullWidth={isMobile} onClick={onClose}>
            FAZER ISSO MAIS TARDE
          </StyledSecondaryButton>
          <StyledButton fullWidth={isMobile} onClick={handleSubmit} disabled={!hasValidChanges}>
            CONFIRMAR
          </StyledButton>
        </StyledDialogActions>
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default ProfileUpdateModal;
